import { Box } from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import FormBase from "../../../../forms/FormBase";
import { RecadastramentoContext } from "../../../../context/RecadastramentoContext";
import TmpTitleFormCustom from "../../../../components/tempo/TmpTitleFormCustom/TmpTitleFormCustom";
import ReRegistrationTeamMembersComponent from "../../../components/tempo/Recadastramento/ReRegistrationTeamMembersComponent";
import { ReRegistrationTeamMembersFormItem } from "../../../../forms/recadastramento/ReRegistrationTeamMembersForm";
import TmpTypographyCustom from "../../../../components/tempo/TmpTypographyCustom/TmpTypographyCustom";
import { ReRegistrationProfessionalTeamFormItem } from "../../../../forms/recadastramento/ReRegistrationProfessionalTeamForm";
import ReRegistrationProfessionalTeamComponent from "../../../components/tempo/Recadastramento/ReRegistrationProfessionalTeamComponent";
import TmpShapeCustom from "../../../../components/tempo/TmpShapeCustom/TmpShapeCustom";
import MedicalTeamService from "../../../../services/MedicalTeamService";

export default function MedicalTeamStep() {

    const { state, dispatch } = useContext(RecadastramentoContext);
    const [myTeams, setMyTeams] = useState<string[]>()

    const onInputChange = (name: string, form: FormBase, value: any) => {
        dispatch({
            type: "UPDATE_FORM",
            payload: { form, value, name },
        });
    };

    const onCrudMyTeamMembersAction = (subTypeParam: "InsertOrUpdate" | 'Delete' | 'Cancel' | 'Edit', formItem?: ReRegistrationTeamMembersFormItem) => {
        dispatch({
            type: "CRUD_FORM_REREGISTRATION_TEAM_MEMBERS",
            payload: { subType: subTypeParam, item: formItem },
        });
    };

    const onCrudTeamsIParticipaInteAction = (subTypeParam: "InsertOrUpdate" | 'Delete' | 'Cancel' | 'Edit', formItem?: ReRegistrationProfessionalTeamFormItem) => {
        dispatch({
            type: "CRUD_FORM_REREGISTRATION_TEAM_I_PARTICIPATE_IN",
            payload: { subType: subTypeParam, item: formItem },
        });
    };


    useEffect(() => {
        MedicalTeamService.getMyTeams().then((e: any) => setMyTeams(e))
    }, []);


    return (
        <div>
            <TmpShapeCustom>

                <TmpTitleFormCustom marginTop={2} marginBottom={4}>
                    Minhas equipes
                </TmpTitleFormCustom>
                <Box mt={2} mb={2}>

                    {myTeams !== undefined && myTeams.map((team, index) => (
                        <TmpTypographyCustom key={index} component="subtitle" size="medium" variant="h4" id="meus-titulos">
                            <li>{team}</li>
                        </TmpTypographyCustom>
                    ))}

                    {(myTeams === undefined || myTeams.length === 0) ?
                        (
                            <TmpTypographyCustom component="caption" size="medium" variant="h4" id="meus-titulos">
                                <li>Sem informações para serem apresentadas.</li>
                            </TmpTypographyCustom>
                        )
                        : null
                    }

                </Box>
            </TmpShapeCustom>

            {myTeams !== undefined && myTeams.length > 0 ?
                <>
                    <br />
                    <TmpShapeCustom>

                        <TmpTitleFormCustom marginTop={2} marginBottom={4}>
                            Participantes da minha equipe
                        </TmpTitleFormCustom>

                        <Box mt={2} mb={4}>
                            <ReRegistrationTeamMembersComponent
                                ReRegistrationTeamMembersForm={state.ReRegistrationTeamMembersForm}
                                onCancelItem={() => { onCrudMyTeamMembersAction("Cancel") }}
                                onInserOrUpdateItem={() => { onCrudMyTeamMembersAction("InsertOrUpdate") }}
                                onEditClick={(e: ReRegistrationTeamMembersFormItem) => { onCrudMyTeamMembersAction("Edit", e) }}
                                onDeleteClick={(e: ReRegistrationTeamMembersFormItem) => { onCrudMyTeamMembersAction("Delete", e) }}
                                onInputChange={onInputChange} />
                        </Box>
                    </TmpShapeCustom>
                </>
                : null
            }
            <br />
            <TmpShapeCustom>

                <TmpTitleFormCustom marginTop={2}>
                    Equipes que você participa
                </TmpTitleFormCustom>

                <Box mt={2} mb={4}>

                    <ReRegistrationProfessionalTeamComponent
                        ReRegistrationProfessionalTeamForm={state.ReRegistrationProfessionalTeamForm}
                        onCancelItem={() => { onCrudTeamsIParticipaInteAction("Cancel") }}
                        onInserOrUpdateItem={() => { onCrudTeamsIParticipaInteAction("InsertOrUpdate") }}
                        onEditClick={(e: ReRegistrationProfessionalTeamFormItem) => { onCrudTeamsIParticipaInteAction("Edit", e) }}
                        onDeleteClick={(e: ReRegistrationProfessionalTeamFormItem) => { onCrudTeamsIParticipaInteAction("Delete", e) }}
                        onInputChange={onInputChange} />
                </Box>
            </TmpShapeCustom>

            <br />


        </div >
    )
}